module.exports = __webpack_public_path__ + "img/154.7f2e19d4.jpg";